import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.DELETE_REQUEST]: isLoading,
  [actionTypes.DELETE_SUCCESS]: isEnding,
  [actionTypes.DELETE_FAILURE]: isEnding,
});
